module.exports = __webpack_public_path__ + "img/section10_de.7aa4071.png";